import { ArrowSmallRightIcon, BuildingStorefrontIcon, TruckIcon } from '@heroicons/react/20/solid';
import { Divider } from '@mui/material';
import { ShipApproachIcon } from 'assets/icons/ShipApproachIcon';
import { Routes } from 'constants/pages';
import { PresetView } from 'pages/Shipments/Containers/types';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { useCountFromAPI } from '../../hooks';
import { StatusCard } from './StatusCard';

export const StatusCards: React.FC = () => {
  const { inner: activeContainersInner } = useCountFromAPI(PresetView.Active);

  return (
    <div className="space-y-4">
      <div className="space-y-3">
        <Link
          to={Routes.ShipmentsActive}
          className="group flex space-x-1.5 items-center cursor-pointer"
        >
          <h3 className="font-bold">{activeContainersInner}</h3>
          <h3 className="font-medium">active containers</h3>
          <ArrowSmallRightIcon className="h-4 w-4 text-gray-700 group-hover:text-blue-900" />
        </Link>
        <Divider />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <StatusCard
          textColor="text-vessel-900"
          backgroundColor="bg-vessel-100"
          icon={<ShipApproachIcon />}
          iconClasses="bg-vessel-900 text-vessel-100 p-0.5"
          presetView={PresetView.OnVessel}
          text="containers arriving on vessel"
        />
        <StatusCard
          textColor="text-terminal-900"
          backgroundColor="bg-terminal-100"
          icon={<BuildingStorefrontIcon />}
          iconClasses="bg-terminal-900 text-terminal-100"
          presetView={PresetView.Availability}
          text="containers to be picked up from terminal"
          footerLeft={{
            text: 'With holds',
            presetView: PresetView.WithHolds,
          }}
          footerRight={{
            text: 'Available for pickup',
            presetView: PresetView.AvailableForPickup,
          }}
        />
        <StatusCard
          textColor="text-gatedOut-900"
          backgroundColor="bg-gatedOut-100"
          icon={<TruckIcon />}
          iconClasses="text-gatedOut-900"
          presetView={PresetView.EmptyReturns}
          text="empties to be returned"
          footerLeft={{
            text: '> 2 free days remaining',
            presetView: PresetView.MoreThanTwoFreeDays,
          }}
          footerRight={{
            text: '≤ 2 free days remaining',
            presetView: PresetView.LessThanTwoFreeDays,
          }}
        />
      </div>
    </div>
  );
};
